import {
  AI_VERIFIED_INVOICE_DETAIL,
  AI_VERIFIED_INVOICE_LIST,
  FLAG_AIVERIFIED_INVOICE_DETAIL,
  FLAGGED_INVOICE_DETAIL,
  FLAGGED_INVOICE_LIST,
  PENDING_INVOICE_DETAIL,
  PENDING_INVOICE_LIST,
  PRODUCT_BATCH_PRICING_DROPDOWN,
  REJECT_PENDING_INVOICE_DETAIL,
  REJECTED_INVOICE_DETAIL,
  REJECTED_INVOICE_LIST,
  UPDATE_PRODUCT_PTR,
  VERIFIED_INVOICE_DETAIL,
  VERIFIED_INVOICE_LIST,
  VERIFY_PENDING_INVOICE_DETAIL,
} from "./types";

export const aiVerifiedInvoiceList = (data, onSuccess, onError) => {
  return {
    type: AI_VERIFIED_INVOICE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const aiVerifiedInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: AI_VERIFIED_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const verifiedInvoiceList = (data, onSuccess, onError) => {
  return {
    type: VERIFIED_INVOICE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const verifiedInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: VERIFIED_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const flaggedInvoiceList = (data, onSuccess, onError) => {
  return {
    type: FLAGGED_INVOICE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const flaggedInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: FLAGGED_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const pendingInvoiceList = (data, onSuccess, onError) => {
  return {
    type: PENDING_INVOICE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const pendingInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: PENDING_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const rejectedInvoiceList = (data, onSuccess, onError) => {
  return {
    type: REJECTED_INVOICE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const rejectedInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: REJECTED_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const verifyPendingInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: VERIFY_PENDING_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const rejectPendingInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: REJECT_PENDING_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const productBatchPricingDropDown = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_BATCH_PRICING_DROPDOWN,
    data,
    onSuccess,
    onError,
  };
};

export const updateProductPtr = (data, onSuccess, onError) => {
  return {
    type: UPDATE_PRODUCT_PTR,
    data,
    onSuccess,
    onError,
  };
};

export const flagAiVerifiedInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: FLAG_AIVERIFIED_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};
